module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jRFF4"))).then(() => parcelRequire('1iHdE'));